import React, {useEffect} from 'react'
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {useNavigate, useSearchParams} from "react-router-dom";
import {URL_FAQ_CATEGORY_CREATE, URL_FAQ_CREATE} from "../../../mock/page_urls";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {useQuery} from "react-query";
import {getFaq} from "../../../services/faqSvc";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {FaqCard} from "../../../components/common/faqCard/FaqCard";
import {separateFormatter} from "../../../utils/separateFormatter";
import {KTIcon, useDebounce} from "../../../../_metronic/helpers";

export const FaqsPage = () => {

  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""

  const debouncedSearch = useDebounce(searchQuery, 500);


  const {
    data: faqData,
    isLoading: faqIsLoading,
    refetch: refetchFaq
  } = useQuery(["getFaq", debouncedSearch, page], () => getFaq({
    params: {
      page: page,
      page_size: 10,
      search: debouncedSearch
    }
  }))

  const pageDetails = {
    title: "Tezkor savollar",
    desc: `Jami tezkor savollar soni: (${separateFormatter(faqData?.total_items || 0, " ", "ta")})`,

    buttons: [
      {
        onClick: () => navigate(URL_FAQ_CREATE),
        text: "Qo'shish",
        icon: "plus-square",
      }
    ]
  };

  const totalItems = faqData?.total_items || 0;
  const itemsPerPage = faqData?.page_size || 8;


  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchFaq();
    }
  }, [debouncedSearch, refetchFaq]);

  return (
      <div>
        <PageHeader pageDetails={pageDetails}/>
        <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
          <div className={"w-100 w-100 w-md-250px"}>
            <div className="d-flex align-items-center position-relative my-1">
              <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>
              <input value={searchQuery}
                     onChange={handleSearchChange} type="text" data-kt-user-table-filter="search"
                     className="form-control w-100 w-md-250px ps-12"
                     placeholder="Qidiruv..."/>
            </div>
          </div>
        </div>

        <div className={"mb-10 d-flex flex-column  gap-4 px-0 mx-0"}>
          {faqIsLoading ? <LoaderSection height={"50vh"}/> : faqData?.data?.length === 0 ?
              <EmptySection height={"50vh"}/> :
              <div className={"mb-5"}>
                {faqData?.data?.map((faq) => (
                    <FaqCard key={faq?.id} faq={faq} refetchFaq={refetchFaq}/>
                ))}
                <div className={"mt-10"}>
                  <Pagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                  />
                </div>
              </div>
          }

        </div>

      </div>
  )
}
